<template>
	<div>
		<router-view></router-view>
		
		<!-- loading 效果 -->
		<div v-show="showLoading" style="position: fixed;left: 0;top:0;height: 100%;width: 100%;z-index: 9999999999;display:table;">
			<div style="display:table-cell; vertical-align:middle;text-align: center;">
				<img src="./assets/plugins/loading/loading.gif" />
			</div>
		</div>
		
		<!-- message消息提示框 -->
		<div v-show="showMessage" id="boot_message_box" style="position: fixed;left: 0;top:0;height: 100%;width: 100%;z-index: 9999999999;display:table;">
			<div style="display:table-cell; vertical-align:middle;">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-body" style="padding: 0px;">
							<div class="alert alert-dismissible fade in" :class="messageBgClass" role="alert" style="margin-bottom: 0px;">
								<button type="button" class="close" @click="closeMessage()" aria-label="Close"><span aria-hidden="true">×</span></button>
								<h4 v-html="messageTitle"></h4>
								<p v-html="messageContent" style="font-size: 16px;"></p>
								<p>
									<button type="button" @click="doOkCallback()" class="btn" :class="messageBtnClass">确定</button>
									<button v-if="showCancelBtn" @click="doCancelCallback()" type="button" class="btn btn-default" style="margin-left: 10px;">取消</button>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
    
</template>
<script>
export default {
    name: 'App',
    components: {

    },
    data:function(){
        return {
			
        }
    },
	computed: {
		showLoading: function() {
			return this.$store.state.showLoading || false;
		},
		showMessage: function() {
			let message = this.$store.state.message || {};
			return message!=undefined&&message!=null&&
				message.type!=undefined&&message.type!=null&&message.type.length > 0;
		},
		showCancelBtn:function(){
			let message = this.$store.state.message || {};
			let type = message.type || '';
			return type == 'CONFIRM';
		},
		message: function() {
			return this.$store.state.message || {};
		},
		messageTitle:function(){
			let message = this.$store.state.message || {};
			if(message.type == 'CONFIRM'){
				return '<span class="glyphicon glyphicon-question-sign" style="top:3px"></span>操作确认';
			}
			else if(message.type == 'ERROR'){
				return '<span class="glyphicon glyphicon-info-sign" style="top:3px"></span>错误提示';
			}
			else{
				return '<span class="glyphicon glyphicon-info-sign" style="top:3px"></span>系统消息';
			}
		},
		messageContent:function(){
			let message = this.$store.state.message || {};
			return message.content || '';
		},
		messageBgClass:function(){
			let message = this.$store.state.message || {};
			if(message.type == 'SUCCESS'){
				return "alert-success";
			}
			else if(message.type == 'ERROR'){
				return "alert-danger";
			}
			else{
				return "alert-warning";
			}
		},
		messageBtnClass:function(){
			let message = this.$store.state.message || {};
			if(message.type == 'SUCCESS'){
				return "btn-success";
			}
			else if(message.type == 'ERROR'){
				return "btn-danger";
			}
			else{
				return "btn-warning";
			}
		}
	},
	methods: {
		doOkCallback:function(){
			let message = this.$store.state.message || {};
			if(message && message.okCallBack){
				message.okCallBack.call(this);
			}
			this.hideMessage();
		},
		doCancelCallback:function(){
			let message = this.$store.state.message || {};
			if(message && message.cancelCallBack){
				message.cancelCallBack.call(this);
			}
			this.hideMessage();
		},
		hideMessage: function() {
			this.$store.commit('setMessage',{});
		},
		closeMessage:function(){
			let message = this.$store.state.message || {};
			if(message.type == 'SUCCESS'){
				this.doOkCallback();
			}
			else if(message.type == 'ERROR'){
				this.doOkCallback();
			}
			else{
				this.doCancelCallback();
			}
		}
	}
}
</script>
<style>
	@-webkit-keyframes fadeIn {
		0% {
			opacity: 0; /*初始状态 透明度为0*/
		}
		50% {
			opacity: 0; /*中间状态 透明度为0*/
		}
		100% {
			opacity: 1; /*结尾状态 透明度为1*/
		}
	}
	
	#boot_message_box {
		-webkit-animation-name: fadeIn; /*动画名称*/
		-webkit-animation-duration: 0.2s; /*动画持续时间*/
		-webkit-animation-iteration-count: 1; /*动画次数*/
		-webkit-animation-delay: 0s; /*延迟时间*/
	}
	
	#boot_message_box .modal-content {
		box-shadow: 10px 10px 5px #888888;
		-moz-box-shadow: 10px 10px 5px #888888; /* 老的 Firefox */
		-webkit-box-shadow: 10px 10px 5px #888888;
	}

</style>